var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAjouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.33 138.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a {\n        fill: #f3f3ea;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ajouter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M121.58,83.61H97.08V59.11a22.33,22.33,0,1,0-44.67,0v24.5H27.92A22.33,22.33,0,0,0,5.58,105.95h0a22.33,22.33,0,0,0,22.33,22.33h24.5v24.5a22.33,22.33,0,1,0,44.67,0v-24.5h24.5a22.33,22.33,0,0,0,22.33-22.33h0A22.33,22.33,0,0,0,121.58,83.61Z",
    transform: "translate(-5.58 -36.78)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjouter);
export default __webpack_public_path__ + "static/media/ajouter.6f884117c3594706fd3bb57aa8ea0dd2.svg";
export { ForwardRef as ReactComponent };